import type { TOC } from '@ember/component/template-only';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
import MonogramOrPhoto from 'garaje/components/monogram-or-photo';
import type VisitorProfile from 'garaje/models/visitor-profile';

interface ProfileHeaderSignature {
  Args: {
    visitorProfile: VisitorProfile;
  };
}

export default <template>
  <div class="flex flex-row items-center space-x-5" data-test-profile-header>
    <div>
      <MonogramOrPhoto
        @borderBottom={{false}}
        @large={{true}}
        @name={{@visitorProfile.displayName}}
        @passportPhoto={{@visitorProfile.photoUrl}}
        @rounded="large"
      />
    </div>
    <div class="flex flex-col space-y-2">
      <div class="text-2xl font-bold">{{@visitorProfile.displayName}}</div>
      {{! contact info }}
      <div class="flex flex-col gap-y-2">
        {{#if @visitorProfile.primaryEmail}}
          <div class="flex items-center gap-x-2">
            {{svgJar "ui-email" class="w-4 h-4 text-carbon-50"}}
            <span class="font-semibold">Email address</span>
            <span class="text-carbon-50" data-test-email>{{@visitorProfile.primaryEmail}}</span>
          </div>
        {{/if}}

        {{#if @visitorProfile.formattedPhoneNumber}}
          <div class="flex items-center gap-x-2">
            {{svgJar "ui-phone" class="w-4 h-4 text-carbon-50"}}
            <span class="font-semibold">Phone number</span>
            <span class="text-carbon-50" data-test-phone>{{@visitorProfile.formattedPhoneNumber}}</span>
          </div>
        {{/if}}
      </div>
    </div>
  </div>
</template> satisfies TOC<ProfileHeaderSignature>;
